// assets/pw-gate.js
// Philip Warren delivery gate — ROUTING + UX ONLY. Shopify checkout (native Local
// Delivery + Local Pickup, configured in admin — Phase 1) stays the single source of
// truth for delivery/collection eligibility. This script only decides which destination
// a shopper goes to.
//
// Vintage Superstore (pre-OS-2.0): loaded as a plain <script> after pw-zones.js.
// ES5-safe. No import/export, no dependencies, does NOT use the theme's jQuery.
(function () {
  "use strict";

  var Z = window.PW_ZONES || { prefixes: ["PL", "TR"], matchMode: "area" };

  // Destinations.
  // LOCAL_DEST   = Warren shop entry for PL/TR van-delivery shoppers.
  // COLLECT_DEST = Warren shop entry for collect-in-store shoppers (any postcode);
  //                they choose Local Pickup (Launceston) at checkout.
  // NATIONAL_DEST= hand-off to Pipers with a source tag only (no customer data in URL).
  // LOCAL_DEST + COLLECT_DEST assume Shopify Local Delivery / Local Pickup (Phase 1)
  // are configured, or these paths dead-end at checkout.
  var LOCAL_DEST = "/collections/all";
  var COLLECT_DEST = "/collections/all";
  var NATIONAL_DEST = "https://pipers.co/discount/WARRENS20?redirect=/pages/warrens%3Futm_source%3Dwarrens%26utm_medium%3Dpostcode-gate%26utm_campaign%3Dwarrens20";
  var GATE_PATH = "/pages/start";

  // Outward code of the postcode the shopper just entered, held between "submit" and
  // their nationwide-vs-collect choice on the result screen.
  var pendingOutward = "";

  // ---------- postcode helpers ----------
  function outwardCode(raw) {
    var pc = String(raw).toUpperCase().replace(/\s+/g, "");
    return pc.length > 3 ? pc.slice(0, pc.length - 3) : pc; // UK inward code is always 3 chars
  }
  function areaPrefix(out) { return (out.match(/^[A-Z]+/) || [""])[0]; }
  function isWarrenZone(raw) {
    var out = outwardCode(raw);
    return Z.matchMode === "district"
      ? Z.prefixes.indexOf(out) !== -1
      : Z.prefixes.indexOf(areaPrefix(out)) !== -1;
  }
  function looksLikePostcode(raw) {
    return /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i.test(String(raw).trim());
  }

  // ---------- persistence (cookie + localStorage) ----------
  function save(payload) {
    var v = encodeURIComponent(JSON.stringify(payload));
    document.cookie = "pw_zone=" + v + ";path=/;max-age=" + (60 * 60 * 24 * 30) + ";samesite=lax";
    try { localStorage.setItem("pw_zone", JSON.stringify(payload)); } catch (e) {}
  }
  function clearZone() {
    document.cookie = "pw_zone=;path=/;max-age=0;samesite=lax";
    try { localStorage.removeItem("pw_zone"); } catch (e) {}
  }
  function readSaved() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem("pw_zone")); } catch (e) {}
    if (!s) {
      var m = document.cookie.match(/(?:^|;\s*)pw_zone=([^;]+)/);
      if (m) { try { s = JSON.parse(decodeURIComponent(m[1])); } catch (e2) {} }
    }
    return s;
  }

  // "national" → Pipers; "collect" → Warren pickup; anything else ("local") → Warren delivery.
  function destFor(cohort) {
    if (cohort === "national") { return NATIONAL_DEST; }
    if (cohort === "collect") { return COLLECT_DEST; }
    return LOCAL_DEST;
  }
  function hasZone() { var z = readSaved(); return !!(z && z.cohort); }
  function commit(cohort, out) {
    save({ cohort: cohort, outward: out, ts: Date.now() });
    var dest = destFor(cohort);
    // Local/collect shoppers return to the product/collection they were heading for.
    // National (Pipers) always goes to Pipers.
    if (cohort !== "national") {
      try {
        var intended = sessionStorage.getItem("pw_intended");
        if (intended) { sessionStorage.removeItem("pw_intended"); dest = intended; }
      } catch (e) {}
    }
    window.location.assign(dest);
  }

  // Non-PL/TR shoppers see a choice (nationwide vs collect) instead of a hard redirect.
  function showResult(out) {
    var ask = document.getElementById("pw-ask");
    var result = document.getElementById("pw-result");
    var outEl = document.getElementById("pw-result-outward");
    pendingOutward = out;
    if (outEl) { outEl.textContent = out; }
    if (ask) { ask.style.display = "none"; }
    if (result) { result.hidden = false; }
  }
  function hideResult() {
    var ask = document.getElementById("pw-ask");
    var result = document.getElementById("pw-result");
    if (result) { result.hidden = true; }
    if (ask) { ask.style.display = ""; }
  }

  function decideAndRoute(raw) {
    var out = outwardCode(raw);
    if (isWarrenZone(raw)) { commit("local", out); return; }
    // Outside PL/TR: offer nationwide (Pipers) OR collect-in-store if the result UI exists.
    if (document.getElementById("pw-result")) { showResult(out); }
    else { commit("national", out); } // fallback (no result UI present) → straight to Pipers
  }

  var onGatePage = window.location.pathname.indexOf(GATE_PATH) === 0;

  // ---------- gate page wiring (only runs if the gate UI is present) ----------
  var btn = document.getElementById("pw-submit");
  if (btn) {
    var input = document.getElementById("pw-postcode");
    var err = document.getElementById("pw-error");
    var submit = function () {
      var raw = (input || {}).value || "";
      if (!raw.trim()) { if (err) { err.textContent = "Please enter a postcode."; } return; }
      if (!looksLikePostcode(raw)) { if (err) { err.textContent = "We couldn't read that postcode — please check it."; } return; }
      if (err) { err.textContent = ""; }
      decideAndRoute(raw);
    };
    btn.addEventListener("click", submit);
    if (input) {
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) { e.preventDefault(); submit(); }
      });
      input.addEventListener("input", function () { if (err) { err.textContent = ""; } });
    }

    // Result-screen choices (save the chosen cohort, then route).
    var goNational = document.getElementById("pw-go-national");
    if (goNational) { goNational.addEventListener("click", function (e) { e.preventDefault(); commit("national", pendingOutward); }); }
    var goCollect = document.getElementById("pw-go-collect");
    if (goCollect) { goCollect.addEventListener("click", function (e) { e.preventDefault(); commit("collect", pendingOutward); }); }
    var back = document.getElementById("pw-back");
    if (back) { back.addEventListener("click", function (e) { e.preventDefault(); hideResult(); if (err) { err.textContent = ""; } if (input) { input.focus(); } }); }
  }

  var saved = readSaved();

  // ---------- return-visit skip ----------
  // Rewrite Shop link(s) by HREF (not a data-attribute we can't inject into the
  // settings-driven Vintage nav). Text is unchanged, so no visible flash.
  if (saved && saved.cohort) {
    var dest = destFor(saved.cohort);
    var links = document.querySelectorAll('a[href$="/pages/start"], a[href="/pages/start"]');
    Array.prototype.forEach.call(links, function (a) { a.href = dest; });
    // Gated shop buttons (data-pw-gate) keep their own destination for local/collect,
    // but national shoppers are always sent to Pipers.
    if (saved.cohort === "national") {
      var gated = document.querySelectorAll("a[data-pw-gate]");
      Array.prototype.forEach.call(gated, function (a) { a.href = NATIONAL_DEST; });
    }
  }

  // ---------- reversibility affordance (persistent, quiet, site-wide) ----------
  function renderFlag(s) {
    if (document.getElementById("pw-zone-flag")) { return; }
    var body = document.body || document.documentElement;
    if (!body) { return; }

    var wrap = document.createElement("div");
    wrap.id = "pw-zone-flag";
    // The WHOLE pill is the tap target (not just the word "change"), it clears the
    // iPhone home bar via safe-area-inset, and sits above theme bars (z-index).
    var baseBottom = document.querySelector(".pw-stickybar") ? 76 : 16;
    wrap.style.cssText = "position:fixed;left:16px;" +
      "bottom:" + baseBottom + "px;" +
      "bottom:calc(" + baseBottom + "px + env(safe-area-inset-bottom, 0px));" +
      "z-index:9990;cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation;" +
      "display:inline-flex;align-items:center;gap:9px;background:#00446B;color:#fff;" +
      "font:400 13px/1.35 system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;" +
      "padding:13px 18px;border-radius:999px;box-shadow:0 6px 20px rgba(0,30,50,.22);" +
      "max-width:calc(100vw - 32px)";

    var text;
    if (s.cohort === "local") { text = "Delivering to " + (s.outward || "your area") + " ••••"; }
    else if (s.cohort === "collect") { text = "Collecting at Launceston"; }
    else { text = "Delivering nationwide"; }

    wrap.setAttribute("role", "button");
    wrap.setAttribute("tabindex", "0");
    wrap.setAttribute("aria-label", text + " — change delivery postcode");

    var label = document.createElement("span");
    label.textContent = text;

    var sep = document.createElement("span");
    sep.textContent = "—";
    sep.style.opacity = ".55";

    var change = document.createElement("span");
    change.textContent = "change";
    change.style.cssText = "color:#D6DE52;text-decoration:underline;text-underline-offset:2px;font-weight:600";

    function doChange() { clearZone(); window.location.assign(GATE_PATH); }
    wrap.addEventListener("click", function (e) { e.preventDefault(); doChange(); });
    wrap.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); doChange(); }
    });

    wrap.appendChild(label);
    wrap.appendChild(sep);
    wrap.appendChild(change);
    body.appendChild(wrap);
  }

  if (saved && saved.cohort && !onGatePage) {
    renderFlag(saved);
  }

  // ---------- ORDER GATE ----------
  // No ordering without a chosen delivery zone. Catches every route into the shop
  // (homepage product cards, direct product/collection links, Google), not just the
  // "Shop Online" links — so shoppers can't checkout to the wrong place by accident.
  // Browsing stays open (SEO-safe); only add-to-basket and the cart require a zone.
  (function () {
    // Cart page (and /checkout) with no zone → send to the gate first.
    var p = window.location.pathname;
    if ((p.indexOf("/cart") === 0 || p.indexOf("/checkout") === 0) && !hasZone()) {
      window.location.replace(GATE_PATH);
      return;
    }

    // Add-to-basket: intercept the /cart/add form submit until a zone is chosen.
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) { return; }
      if ((f.getAttribute("action") || "").indexOf("/cart/add") !== -1 && !hasZone()) {
        e.preventDefault();
        window.location.assign(GATE_PATH);
      }
    }, true);

    // Shop navigation: clicking a product or collection link with no zone → gate first.
    // hrefs stay intact (Google still crawls them); we remember the target so local/collect
    // shoppers land back on the product they clicked after choosing a zone.
    document.addEventListener("click", function (e) {
      if (hasZone()) { return; }
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
      var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!a || a.target === "_blank") { return; }
      var href = a.getAttribute("href") || "";
      // Also catch the bare /collections index and any link marked data-pw-gate
      // (e.g. the header Shop Online button, whose destination is a theme setting).
      if (href.indexOf("/products/") !== -1 || href.indexOf("/collections/") !== -1 ||
          /^\/collections\/?(?:[?#]|$)/.test(a.pathname || "") || a.hasAttribute("data-pw-gate")) {
        e.preventDefault();
        try { sessionStorage.setItem("pw_intended", a.href); } catch (err) {}
        window.location.assign(GATE_PATH);
      }
    }, true);
  })();
})();
